import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ResponseModel, EnvironmentModel } from '@generic/index';

import { ChangePasswordModel } from '../models/ChangePasswordModel';
import { ActivateAccountModel } from '../models/ActivateAccountModel';
import { ForgotPasswordModel } from '../models/ForgotPasswordModel';
import { ResetPasswordModel } from '../models/ResetPasswordModel';
import {FinalResponse} from '@app-so/participants/models/CertificateValidationModel';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  baseUrl: string;

  constructor(private http: HttpClient, private environment: EnvironmentModel) {
    /*this.baseUrl = `${this.environment.apiEndpoint}/account`;*/
    this.baseUrl = `${this.environment.apiEndpoint}`;
  }

  changePassword(model: ChangePasswordModel) {
    return this.http.patch<FinalResponse>(`${this.baseUrl}/auth/api/changePassword`, model);
  }

  resetPassword(model: ResetPasswordModel) {
    return this.http.patch<FinalResponse>(`${this.baseUrl}/auth/api/resetPassword`, model);
  }

  activate(model: ActivateAccountModel) {
    return this.http.post<ResponseModel>(`${this.baseUrl}/activate`, model);
  }

  sendForgotPasswordEmail(user: ForgotPasswordModel) {
    return this.http.post<FinalResponse>(`${this.baseUrl}/api/forgotpassword`, user);
  }

  confirmPasswordReset(model: ResetPasswordModel) {
    return this.http.post<ResponseModel>(`${this.baseUrl}/reset-password`, model);
  }

  enable2fa(username: string, password: string, code: string) {
    return this.http.post<any>(`${this.baseUrl}/2fa/enable`, {
      username: username,
      password: password,
      code: code
    });
  }

  getAuthenticatorKey(username: string, password: string) {
    return this.http.post<any>(`${this.baseUrl}/2fa/key`, {
      username: username,
      password: password
    });
  }
}
